if (!customElements.get('testimonials-slider')) {
  customElements.define(
    'testimonials-slider',
    class TestimonialsSlider extends HTMLElement {
      constructor() {
        super();

        this.flkty = null;
        this.onResizeCallback = () => this.onResize();
      }

      connectedCallback() {
        this.container = this.closest('[data-section-type="testimonials"]');
        this.slides = this.querySelectorAll('[data-item]');
        this.listen();
        // Defer initial sizing until everything is fully loaded
        window.addEventListener('load', this.onResizeCallback, {once: true});
      }

      onResize() {
        this.checkSlideCount();
        if (this.flkty !== null) {
          this.flkty.resize();

          if (this.flkty.size.width >= this.flkty.slideableWidth) this.destroySlider();
        }
      }

      checkSlideCount() {
        // Destroy slider if there are 3 slides on desktop or 2 on tablet
        const slidesCount = this.slides.length;
        const twoSlidesOnTablet = Boolean(slidesCount == 2 && window.innerWidth >= theme.sizes.small);
        const singleSlide = Boolean(slidesCount == 1);

        if (twoSlidesOnTablet || singleSlide) {
          this.destroySlider();
          return;
        }

        if (!this.flkty) {
          this.initSlider();
          return;
        }

        if (this.flkty) {
          if (!this.flkty.isActive) this.initSlider();

          // Destroy slider if slidable container is smaller than the slider's container width
          this.flkty.slideableWidth > this.flkty.size.width ? this.initSlider() : this.destroySlider();
        }
      }

      initSlider() {
        this.flkty = new window.theme.Flickity(this, {
          cellSelector: '[data-item]',
          prevNextButtons: true,
          pageDots: true,
          groupCells: true,
          cellAlign: this.dataset.sliderAlignment,
          contain: true,
          adaptiveHeight: false,
          on: {
            ready: () => {
              this.slidesTabIndex();
              requestAnimationFrame(() => {
                this.querySelectorAll('.flickity-button').forEach((button) => {
                  window.theme.wrap(button, 'flickity-button-holder');
                });

                if (this.flkty) {
                  this.flkty.resize();
                }
              });
            },
            change: () => {
              this.slidesTabIndex();
            },
          },
        });

        if (!window.theme.isMobile()) {
          this.container.classList.add('has-arrows');
        } else {
          this.container.classList.remove('has-arrows');
        }
        this.createResizeClass();
      }

      createResizeClass() {
        if (typeof window.theme.Flickity.prototype._createResizeClass === 'function') return;

        window.theme.Flickity.prototype._createResizeClass = function () {
          this.element.classList.add('carousel--resize');
        };

        window.theme.Flickity.createMethods.push('_createResizeClass');

        const resize = window.theme.Flickity.prototype.resize;
        window.theme.Flickity.prototype.resize = function () {
          this.element.classList.remove('carousel--resize');
          resize.call(this);
          this.element.classList.add('carousel--resize');
        };
      }

      slidesTabIndex() {
        const slider = window.theme.Flickity.data(this);

        slider.cells.forEach((slide) => {
          let tabIndex = '-1';
          if (slide.element.classList.contains('is-selected')) {
            tabIndex = '0';
          }

          slide.element.querySelectorAll('a, button').forEach((link) => {
            link.setAttribute('tabindex', tabIndex);
          });
        });
      }

      destroySlider() {
        if (!this.classList.contains('flickity-enabled')) return;

        if (this.flkty !== null) {
          // Revert 'flickity-button' elements to their original positions for proper slider destruction
          this.querySelectorAll('.flickity-button')?.forEach((button) => {
            const parent = button.parentNode;
            if (parent && parent.classList.contains('flickity-button-holder')) {
              parent.parentNode.insertBefore(button, parent);
              parent.parentNode.removeChild(parent);
            }
          });

          this.flkty.destroy();
        }

        this.container.classList.remove('has-arrows');
      }

      listen() {
        document.addEventListener('theme:resize:width', this.onResizeCallback);
      }

      disconnectedCallback() {
        document.removeEventListener('theme:resize:width', this.onResizeCallback);
        window.removeEventListener('load', this.onResizeCallback);
      }
    }
  );
}
